import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { CIRCUIT_CATEGORIES as CircuitCategory, EQUIPMENT_TYPE as EquipmentType, TRANSLATIONS } from '../../../../../utils/constant.utils';
import { ERROR_TYPE } from '../../../../../constants/external-constants'; 
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { planTypeOptions, getVendorDetails, getAddresses, addZeroes } from '../../order-request.functions';

import { actions } from 'react-redux-form';

import {
    portInLocationModelA
    , portInSubscriptionModelA
    , portInBusinessModelA

    //ACTIONS
    , setUserLocation
    , setCountryOptions
    , setAddressOptions
    , setPlanOptions
    , setVendorOptions
    , setSimOptions
    , setVendorDetails
    , setServiceTypeDetails
    , setDeviceOptions
    , setDeviceAccessories
    , setPrimaryPlanDetails
    , setPurposeOfUseOptions
    , setBusinessCaseOptions
    , setShowDeviceOptions
    , setShowOtherAddress
    , setFormSubmitted
    , setFormSubmitting
    , setLoading
    , getCircuitTypes
    , getMobileServiceTypes
    , getVendors
    , getPlanComponent
    , getOrderRequestForm
    , setMobileError

    , setCountryLoading
    , setAddressLoading
    , setVendorLoading
    , setCircuitTypesLoading
    , setMobServiceTypeLoading
    , setPlanOptionLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-port-in.settings';

export const portInLocationModelAInitialState = portInLocationModelA;
export const portInSubscriptionModelAInitialState = portInSubscriptionModelA;
export const portInBusinessModelAInitialState = portInBusinessModelA;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const defaultState = () => ({
    userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , simOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , planOptions: []
    , orderOptions: []
    , deviceOptions: []
    , deviceAccessories: []
    , vendorDetails: {
        Currency: ''
    }
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , primaryPlanDetail: { ...planDetailConst }
    , purposeOfUseOptions: []
    , businessCaseOptions: []
    , showDeviceOptions: false
    , showOtherAddress: false
    , formSubmitted: false
    , isLoading: false
    , circuitTypeOptions: []
    , mobileServiceTypeOptions: []
    , plansDatatable: []
    , totalOrderCost: 0
    , orderRequest: {
        Addresses: [{ id: '', value: '' }],
        LocationOrderModel: {},
        User: {},
        Currency: '',
        SubscriptionModel: {},
        BusinessJustificationModel: {
            IsTaxable: false
        },
        WirelineSubscriptionModel: {}
    }
    , formSubmitting: false
    , loadingSubscriptionForm: false
    , vendorOptions: []

    , countryPage: 1
    , hasMoreCountry: true
    , isCountryLoading: false

    , addressPage: 1
    , hasMoreAddress: true
    , isAddressLoading: false

    , vendorPage: 1
    , hasMoreVendor: true
    , isVendorLoading: false

    , circuitTypePage: 1
    , hasMoreCircuitType: true
    , isCircuitTypeLoading: false

    , mobServiceTypePage: 1
    , hasMoreMobServiceType: true
    , isMobServiceTypeLoading: false

    , planTypePage: 1
    , hasMorePlanType: true
    , isPlanTypeLoading: false
});

const initialState = defaultState();

export const wirelessPortInActions = {
    getNewPortInFormData: (orderId) => async (dispatch, state) => {
        const { requestTypeId } = state().createRequest;
        const { BillingAddress } = state().requestDetail.requestData;
        const { wirelessPortInLocationFormA } = state().form;
        const pageIndex = 1;
        const pageSize = 15;

        var data = {
            RequestTypeId: requestTypeId
            , User: { ...getUserData() }
        };

        dispatch({
            type: setLoading,
            isLoading: true
        });

        var res = await httpPost('external/orderRequest/getOrderForm', data);

        if (res != null) {
            const countryName = wirelessPortInLocationFormA.country ? wirelessPortInLocationFormA.country : orderId ? BillingAddress?.CountryName ?? '' : '';
            await getCountries(dispatch, pageIndex, countryName)

            dispatch({ type: setUserLocation, data: res.UserLocation });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
            dispatch({ type: setBusinessCaseOptions, data: res.BusinessJustification });
            dispatch({ type: setShowOtherAddress, data: BillingAddress?.IsOtherLocation ?? false});

            if (res.Countries?.length == 1) {
                dispatch(actions.change('wirelessPortInLocationFormA.countryCode', res.Countries[0].Key));
            }

            dispatch({
                type: getOrderRequestForm,
                orderRequest: res
            });
        }

        if (orderId) {
            const { requestData } = state().requestDetail;
            var userData = getUserData();

            const { showOtherAddress } = state().wirelessPortInRequest;
            const addressValue = showOtherAddress ? 'Other' : requestData.BillingAddress.DeliveryAddress;

            await getAddresses(dispatch, setAddressOptions, requestData.BillingAddress.CountryCode, showOtherAddress, pageIndex, addressValue, setAddressLoading);
            await getVendorOptions(dispatch, requestData.BillingAddress.CountryName, 1, requestData.Subscription.VendorName);
            await getCircuitTypesByCategory(dispatch, CircuitCategory.mobile, pageIndex, pageSize, requestData.Subscription.CircuitType);
            await planTypeOptions(dispatch, setPlanOptions, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, pageIndex, requestData.Subscription.Plan, setPlanOptionLoading);
            await getMobileServiceTypeOptions(dispatch, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, userData.employeeID, pageIndex, pageSize, requestData.Subscription.Device?.EquipmentModel);
           
            dispatch(actions.change('wirelessPortInLocationFormA.country', requestData.BillingAddress.CountryName));
            dispatch(actions.change("wirelessPortInLocationFormA.countryCode", requestData.BillingAddress.CountryCode));
            dispatch(actions.change("wirelessPortInLocationFormA.locationId", requestData.BillingAddress.LocationId));
            dispatch(actions.change("wirelessPortInLocationFormA.deliveryAddress", requestData.BillingAddress.DeliveryAddress));
            dispatch(actions.change("wirelessPortInLocationFormA.otherDeliveryAddress", requestData.BillingAddress.OtherDeliveryAddress));
            dispatch(actions.change("wirelessPortInLocationFormA.otherDeliveryAddressId", requestData.BillingAddress.OtherDeliveryAddressId));

            dispatch(actions.change("wirelessPortInSubscriptionFormA.personalMobile", requestData.Subscription.PersonalMobile));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.currentVendor", requestData.Subscription.CurrentVendor));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.accountNumber", requestData.Subscription.AccountNumber));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.portPinCode", requestData.Subscription.PortPinCode));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.currentBillingAddress", requestData.Subscription.CurrentBillingAddress));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.vendorDetailId", requestData.Subscription.VendorDetailId));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.circuitTypeId", requestData.Subscription.CircuitTypeId));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.equipmentInventoryId", requestData.Subscription.EquipmentInventoryId));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.phoneCaseAccessory", requestData.Subscription.PhoneCaseAccessory));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.planId", requestData.Subscription.PlanId));

            dispatch(actions.change("wirelessPortInBusinessFormA.purposeOfUseId", requestData.BusinessJustification.PurposeOfUseId));
            dispatch(actions.change("wirelessPortInBusinessFormA.busJustiCodeDetailId", requestData.BusinessJustification.BusJustiCodeDetailId));
            dispatch(actions.change("wirelessPortInBusinessFormA.businessJustification", requestData.BusinessJustification.BusinessJustification));
            dispatch(actions.change("wirelessPortInBusinessFormA.additionalInformation", requestData.BusinessJustification.AdditionalInformation));
            dispatch(actions.change("wirelessPortInBusinessFormA.termAgreement", requestData.BusinessJustification.TermAgreement));

        }

        dispatch({
            type: setLoading,
            isLoading: false
        });
    }
    , setRequestorAddress: () => async (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().wirelessPortInRequest;
        const { requestOnBehalfData } = state().createRequest;
        const pageIndex = 1;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        await getAddresses(dispatch, setAddressOptions, location.CountryCode, showOtherAddress, pageIndex, location.DeliveryAddress, setAddressLoading);
        await getCountries(dispatch, 1, location.CountryName);

        dispatch(actions.change('wirelessPortInLocationFormA.country', location.CountryName));
        dispatch(actions.change('wirelessPortInLocationFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessPortInLocationFormA.locationId', location.LocationId));
        dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', location.DeliveryAddress));
        dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''));

        const { wirelessPortInLocationFormA } = state().form;
        await getVendorOptions(dispatch, wirelessPortInLocationFormA.country, 1, '');

    }
    , onAddressSelect: (model, value) => (dispatch, state) => {

        const { addressOptions } = state().wirelessPortInRequest;

        dispatch(actions.change(model, value));

        const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value)?.Value : '';

        dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', deliveryAddress));
        dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''));

    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {
        const { countryOptions, showOtherAddress } = state().wirelessPortInRequest;
        const pageIndex = 1;

        dispatch(actions.change(model, value));
        let country = countryOptions.find(o => o['Key'] === value)?.Value;
        if (value) {
            dispatch(actions.change('wirelessPortInLocationFormA.country', country));
        }

        dispatch(actions.reset('wirelessPortInLocationFormA.locationId'));
        dispatch(actions.reset('wirelessPortInLocationFormA.deliveryAddress'));
        dispatch(actions.reset('wirelessPortInLocationFormA.otherDeliveryAddress'))
        resetSubscriptionFormOnLocationChange(dispatch);

        await getAddresses(dispatch, setAddressOptions, value, showOtherAddress, pageIndex, '', setAddressLoading);
        await getVendorOptions(dispatch, country, 1, '');

    }
    , onVendorSelect: (vendorDetailId) => async (dispatch, state) => {
        const { wirelessPortInSubscriptionFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const pageIndex = 1;
        const pageSize = 15;

        var userData = getUserData();
        if (isRequestOnBehalf) {
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        dispatch(actions.reset('wirelessPortInSubscriptionFormA.orderOptionId'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.equipmentCatalogId'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.mobileServiceModel'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.accessoryDetailsModel'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.planId'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.planDetailsModel'));
        dispatch(actions.setErrors('wirelessPortInSubscriptionFormA.equipmentInventoryId', false));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.circuitTypeId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.equipmentInventoryId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.phoneCaseAccessory"));
        dispatch({ type: getPlanComponent, plansDatatable: [], totalOrderCost: 0 });
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });

        getCircuitTypesByCategory(dispatch, CircuitCategory.mobile, pageIndex, pageSize, '');
        getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, vendorDetailId)
    }
    , onCircuitTypeSelect: (circuitTypeId) => async (dispatch, state) => {
        const { wirelessPortInSubscriptionFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const pageIndex = 1;
        const pageSize = 15;

        var userData = getUserData();
        if (isRequestOnBehalf) {
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        planTypeOptions(dispatch, setPlanOptions, wirelessPortInSubscriptionFormA.vendorDetailId, circuitTypeId, pageIndex, '', setPlanOptionLoading);
        getMobileServiceTypeOptions(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, circuitTypeId, userData.employeeID, pageIndex, pageSize, '');
        dispatch(actions.setErrors("wirelessPortInSubscriptionFormA.equipmentInventoryId", false));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.equipmentCatalogId'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.mobileServiceModel'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.accessoryDetailsModel'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.planId'));
        dispatch(actions.reset('wirelessPortInSubscriptionFormA.planDetailsModel'));
        dispatch(actions.setErrors('wirelessPortInSubscriptionFormA.equipmentInventoryId', false));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.circuitTypeId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.equipmentInventoryId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.phoneCaseAccessory"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.planId"));
        dispatch({ type: getPlanComponent, plansDatatable: [], totalOrderCost: 0 });
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
    }
    , onOrderSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.equipmentCatalogId', 0));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });

        const isAccessory = value == EquipmentType.Accessory;
        dispatch({ type: setShowDeviceOptions, data: isAccessory });

        if (isAccessory) {

            const { wirelessPortInSubscriptionFormA } = state().form;
            const { requestOnBehalfData } = state().createRequest;
            var employeeId = requestOnBehalfData.EmployeeId > 0 ? requestOnBehalfData.EmployeeId : sessionStorage.getItem('EmployeeID');
            getDeviceAccessories(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, employeeId);
        }

    }
    , onServiceTypeSelect: (model, value, orderId) => async (dispatch, state) => {
        const { requestOnBehalfData } = state().createRequest;
        const { mobileServiceTypeOptions } = state().wirelessPortInRequest;

        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', []));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        await getServiceTypeDetails(dispatch, value);

        var mobileServiceType = mobileServiceTypeOptions.find(r => r.EquipmentInventoryId == value);
        if (mobileServiceType?.EquipmentTypeId == EquipmentType.Device) {
            var employeeId = requestOnBehalfData.EmployeeId > 0 ? requestOnBehalfData.EmployeeId ?? 0 : sessionStorage.getItem('EmployeeID');

            let locale = state().translation.locale;
            if (locale === null || locale === '')
                locale = TRANSLATIONS['defaultLocaleLanguage'];
            await validateMobileServiceType(dispatch, locale, model, employeeId, value, orderId);
        }
        else {
            dispatch(actions.setErrors(model, false));
        }
    }
    , onPlanSelect: (model, value) => async (dispatch, state) => {
        getPlanComponentByPlan(dispatch, value);
    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().wirelessPortInRequest;
        const { wirelessPortInSubscriptionFormA } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessPortInSubscriptionFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessPortInSubscriptionFormA.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessPortInSubscriptionFormA.accessoryDetailsModel', newAccessories));
    }
    , onSubscriptionFormLoad: () => async (dispatch, state) => {
        dispatch({
            type: setLoading,
            isLoading: true
        });

        await getCircuitTypesByCategory(dispatch, CircuitCategory.mobile);

        dispatch({
            type: setLoading,
            isLoading: false
        });

    }
    , resetWirelessPortInForm: () => (dispatch, state) => {
        resetWirelessPortInForm(dispatch)
    }
    , submitRequest: (orderId) => async (dispatch, state) => {
        const { plansDatatable, orderRequest } = state().wirelessPortInRequest;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelessPortInLocationFormA, wirelessPortInSubscriptionFormA, wirelessPortInBusinessFormA } = state().form;

        var planComponents = plansDatatable.length > 0 ? plansDatatable[0].dataItem : [];

        var subscriptionFormA = {
            ...wirelessPortInSubscriptionFormA,
            planDetails: {
                ...wirelessPortInSubscriptionFormA.planDetails,
                planComponents: planComponents
            }
        }

        let userData = getUserData();
        const requestorEmployeeID = userData.employeeID

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        let circuitId = 0;
        let orderInfoId = 0;
        let orderHistoryId = 0;
        let circuitOrderId = 0;
        if (orderId) {
            const { CircuitId, OrderInfoId, OrderHistoryId, CircuitOrderId } = state().requestDetail.requestData;
            circuitId = CircuitId;
            orderInfoId = OrderInfoId;
            orderHistoryId = OrderHistoryId;
            circuitOrderId = CircuitOrderId;
        }

        var data = {
            ...orderRequest,
            LocationOrderModel: { ...wirelessPortInLocationFormA }
            , SubscriptionModel: { ...subscriptionFormA, EquipmentInventory: wirelessPortInSubscriptionFormA.mobileServiceModel[0].EquipmentModel }
            , BusinessJustificationModel: { ...wirelessPortInBusinessFormA }
            , User: {
                ...userData
            }
            , NoEmail: true
            , RequestTypeId: requestTypeId
            , IsAmending: orderId > 0
            , OrderId: orderId
            , CircuitId: circuitId
            , OrderInfoId: orderInfoId
            , OrderHistoryId: orderHistoryId
            , CircuitOrderId: circuitOrderId
            , RequestorID: Number(requestorEmployeeID)
        };

        dispatch({ type: setFormSubmitted, data: true });
        dispatch({ type: setFormSubmitting, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }
        dispatch({ type: setFormSubmitting, data: false });
        return res;
    }
    , validateMobileNumber: (model, value, orderId) => async (dispatch, state) => {

        await validateMobileNumber(dispatch, model, value, orderId);
    }
    //, getVendorOptions: () => async (dispatch, state) => {
    //    const { wirelessPortInLocationFormA } = state().form;
    //    await getVendorOptions(dispatch, wirelessPortInLocationFormA.country);
    //}
    , loadPortInLocationForm: (orderId) => async (dispatch, state) => {
        const { requestOnBehalfData } = state().createRequest;

        dispatch({
            type: setLoading,
            formName: "Subscription",
            isLoading: true
        });

        const { wirelessPortInSubscriptionFormA } = state().form;
        const { mobileServiceTypeOptions } = state().wirelessPortInRequest
        const pageIndex = 1;

        var employeeId = requestOnBehalfData.EmployeeId > 0 ? requestOnBehalfData.EmployeeId ?? 0 : sessionStorage.getItem('EmployeeID');


        if (wirelessPortInSubscriptionFormA.vendorDetailId && wirelessPortInSubscriptionFormA.circuitTypeId) {

            if (wirelessPortInSubscriptionFormA.equipmentInventoryId) {
                var mobileServiceType = mobileServiceTypeOptions.find(r => r.Key == wirelessPortInSubscriptionFormA.equipmentInventoryId);
                if (mobileServiceType?.EquipmentTypeId == EquipmentType.Device) {
                    let locale = state().translation.locale;
                    if (locale === null || locale === '')
                        locale = TRANSLATIONS['defaultLocaleLanguage'];

                    await validateMobileServiceType(dispatch, locale, "wirelessPortInSubscriptionFormA.equipmentInventoryId", employeeId, wirelessPortInSubscriptionFormA.equipmentInventoryId, orderId);
                }
                await getServiceTypeDetails(dispatch, wirelessPortInSubscriptionFormA.equipmentInventoryId);
            }
        }

        if (wirelessPortInSubscriptionFormA.vendorDetailId && wirelessPortInSubscriptionFormA.circuitTypeId) {
            await planTypeOptions(dispatch, setPlanOptions, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, pageIndex, '', setPlanOptionLoading);
        }

        if (wirelessPortInSubscriptionFormA.planId) {
            await getPlanComponentByPlan(dispatch, wirelessPortInSubscriptionFormA.planId);
        }

        if (wirelessPortInSubscriptionFormA.vendorDetailId) {
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, wirelessPortInSubscriptionFormA.vendorDetailId)
        }

        dispatch({
            type: setLoading,
            formName: "Subscription",
            isLoading: false
        });
    }
    , getCountryList: (page = 1, searchString = '') => async (dispatch) => {
        getCountries(dispatch, 1, searchString);
    }
    , handleCountrySearch: (query) => (dispatch, state) => {
        getCountries(dispatch, 1, query);
    }
    , loadMoreCountry: (searchString) => (dispatch, state) => {
        const { countryPage } = state().wirelessPortInRequest;

        getCountries(dispatch, countryPage + 1, searchString);
    }
    , handleAddressSearch: (searchString) => (dispatch, state) => {
        const { showOtherAddress } = state().wirelessPortInRequest;
        const { wirelessPortInLocationFormA } = state().form;
        const pageIndex = 1;

        getAddresses(dispatch, setAddressOptions, wirelessPortInLocationFormA.countryCode, showOtherAddress, pageIndex, searchString, setAddressLoading);
    }
    , loadMoreAddress: (searchString) => (dispatch, state) => {
        const { addressPage, showOtherAddress } = state().wirelessPortInRequest;
        const { wirelessPortInLocationFormA } = state().form;
        const pageIndex = addressPage + 1;

        getAddresses(dispatch, setAddressOptions, wirelessPortInLocationFormA.countryCode, showOtherAddress, pageIndex, searchString, setAddressLoading);
    }
    , handleVendorSearch: (searchString) => (dispatch, state) => {
        const { wirelessPortInLocationFormA } = state().form;

        if (searchString !== "") {
            getVendorOptions(dispatch, wirelessPortInLocationFormA.country, 1, searchString)
        }
    }
    , loadMoreVendor: (searchString) => (dispatch, state) => {
        const { vendorPage } = state().wirelessPortInRequest;
        const { wirelessPortInLocationFormA } = state().form;

        getVendorOptions(dispatch, wirelessPortInLocationFormA.country, vendorPage + 1, searchString)
    }
    , handleCircuitTypeSearch: (query) => (dispatch, state) => {

        if (query !== "") {

            getCircuitTypesByCategory(dispatch, CircuitCategory.mobile, 1, 15, query);

        }
    }
    , loadMoreCircuitType: (searchString) => (dispatch, state) => {
        const { circuitTypePage } = state().wirelessPortInRequest;

        getCircuitTypesByCategory(dispatch, CircuitCategory.mobile, circuitTypePage + 1, 15, searchString);
    }
    , handleMobServiceTypeSearch: (searchString) => (dispatch, state) => {
        const { wirelessPortInSubscriptionFormA } = state().form;
        var userData = getUserData();

        getMobileServiceTypeOptions(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, userData.employeeID, 1, 15, searchString);
    }
    , loadMoreMobServiceType: (searchString) => (dispatch, state) => {
        const { mobServiceTypePage } = state().wirelessPortInRequest;
        const pageIndex = mobServiceTypePage + 1
        const { wirelessPortInSubscriptionFormA } = state().form;
        var userData = getUserData();

        getMobileServiceTypeOptions(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, userData.employeeID, pageIndex, 15, searchString);
    }
    , handlePlanTypeSearch: (searchString) => (dispatch, state) => {
        const { wirelessPortInSubscriptionFormA } = state().form;
        const pageIndex = 1;

        planTypeOptions(dispatch, setPlanOptions, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, pageIndex, searchString, setPlanOptionLoading);
    }
    , loadMorePlanType: (searchString) => (dispatch, state) => {
        const { planTypePage } = state().wirelessPortInRequest;
        const { wirelessPortInSubscriptionFormA } = state().form;
        const pageIndex = planTypePage + 1;

        planTypeOptions(dispatch, setPlanOptions, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, pageIndex, searchString, setPlanOptionLoading);
    }
}

async function getCountries(dispatch, page = 1, searchString = '') {
    const pageSize = 15;
    dispatch({
        type: setCountryLoading,
        payload: true
    });
    let url = `external/orderRequest/getCountryList/${page}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url)

    try {
        if (res != null) {
            dispatch({
                type: setCountryOptions,
                payload: {
                    country: res,
                    countryPage: page
                }
            });
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        } else {
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        }
    } catch (error) {
        return null
    } finally {
        dispatch({
            type: setCountryLoading,
            payload: false
        });
    }
}

async function resetWirelessPortInForm(dispatch) {
    const pageIndex = 1;

    dispatch({
        type: getPlanComponent,
        plansDatatable: [],
        totalOrderCost: 0
    });
    var res = await httpPost('external/replaceDevice/getCountriesList');

    dispatch(actions.reset('wirelessPortInLocationFormA'));
    dispatch(actions.reset('wirelessPortInSubscriptionFormA'));
    dispatch(actions.reset('wirelessPortInBusinessFormA'));
    dispatch({ type: setFormSubmitted, data: false });

    if (res.length == 1) {
        dispatch(actions.change('wirelessPortInLocationFormA.countryCode', res[0].Key));
        dispatch(actions.change('wirelessPortInLocationFormA.country', res[0].Value));
        getAddresses(dispatch, setAddressOptions, '', false, pageIndex, '', setAddressLoading);
    }
}

function resetRequestOnBehalf(dispatch) {
    dispatch(actions.change('wirelessPortInLocationFormA.locationId', ''));
    dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', ''));
    dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''));
    
    resetSubscriptionFormOnLocationChange(dispatch)
}

function resetSubscriptionFormOnLocationChange(dispatch) {
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.vendorDetailId"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.circuitTypeId"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.equipmentInventoryId"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.phoneCaseAccessory"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.planId"));

   // dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setVendorOptions, data: [] });
    dispatch({ type: setSimOptions, data: [] });
    dispatch({
        type: getMobileServiceTypes,
        mobileServiceTypeOptions: [],
    });
    dispatch({
        type: getVendors,
        vendorOptions: []
    });
    dispatch({
        type: getPlanComponent,
        plansDatatable: [],
        totalOrderCost: 0
    });
}

function resetSubscriptionForm(dispatch) {
    dispatch(actions.reset('wirelessPortInSubscriptionFormA'));
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setVendorOptions, data: [] });
    dispatch({ type: setSimOptions, data: [] });
    dispatch({
        type: getMobileServiceTypes,
        mobileServiceTypeOptions: [],
    });
    dispatch({
        type: getVendors,
        vendorOptions: []
    });
    dispatch({
        type: getPlanComponent,
        plansDatatable: [],
        totalOrderCost: 0
    });
}

async function getDeviceAccessories(dispatch, vendorId, employeeId) {

    var res = await httpGet(`external/orderRequest/getEquipmentData/${vendorId}/${EquipmentType.Accessory}/${employeeId}`);

    if (res != null && res.length > 0) {
        dispatch({ type: setDeviceAccessories, data: res });
    } else {
        dispatch({ type: setDeviceAccessories, data: [] });
    }
}

async function getServiceTypeDetails(dispatch, typeId) {

    var res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', res));
    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', []));
    }

}

async function validateMobileNumber(dispatch, model, mobileNumber, orderId) {
    var res = await httpGet(`external/orderRequest/validateMobileNumber/${mobileNumber}/${orderId ?? 0}`);

    if (res.success && res.message) {
        dispatch(actions.setErrors(model, `Error: ${res.message}`));
        dispatch({
            type: setMobileError,
            mobileError: true
        });        
    } else {
        dispatch({
            type: setMobileError,
            mobileError: false
        });
    }
}

async function getCircuitTypesByCategory(dispatch, categoryid, pageIndex = 1, pageSize = 15, searchString) {

    dispatch({
        type: setCircuitTypesLoading
        , payload: true
    })

    let url = `external/orderRequest/getCircuitTypesByCategoryId/${categoryid}/${pageIndex}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }

    try {
        var res = await httpGet(url);

        dispatch({
            type: getCircuitTypes,
            circuitTypeOptions: res,
            circuitTypePage: pageIndex
        });

        dispatch({
            type: setCircuitTypesLoading
            , payload: false
        })

         dispatch({
            type: setLoading,
            isLoading: false
    });
    }
    catch (e) {
        dispatch({
            type: getCircuitTypes,
            circuitTypeOptions: [],
        });

        dispatch({
            type: setCircuitTypesLoading
            , payload: false
        })
    }
}

async function getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, employeeID, pageIndex = 1, pageSize = 15, searchString = '') {

    dispatch({
        type: setMobServiceTypeLoading
        , payload: true
    })

    let url = `external/orderRequest/getAllMobileServiceTypesOptions/${vendorId}/${circuitTypeId}/${employeeID}/${pageIndex}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url);

    try {
        if (res != null) {
            dispatch({
                type: getMobileServiceTypes,
                mobileServiceTypeOptions: res,
                mobServiceTypePage: pageIndex
            });

            dispatch({
                type: setMobServiceTypeLoading
                , payload: false
            })
        }
    }
    catch (e) {
        dispatch({
            type: getMobileServiceTypes,
            mobileServiceTypeOptions: [],
        });

        return [];
    }
    finally {
        dispatch({
            type: setMobServiceTypeLoading
            , payload: false
        })
    }
}

async function getVendorOptions(dispatch, country, pageIndex, searchString) {

    const pageSize = 15;

    dispatch({
        type: setVendorLoading
        , payload: true
    });

    try {
        let url = `external/orderRequest/getVendorsByCountry/${country}/${pageIndex}/${pageSize}`
        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);

        if (res) {
            dispatch({
                type: getVendors,
                vendor: res
                , vendorPage: pageIndex
            });
        }
        else {
            dispatch({
                type: getVendors,
                vendorOptions: []
            });
        }
    }
    catch (e) {
        dispatch({
            type: getVendors,
            vendorOptions: []
        });

        dispatch({
            type: setVendorLoading
            , payload: false
        });
    }
    finally {
        dispatch({
            type: setVendorLoading
            , payload: false
        });
    }
}

async function validateMobileServiceType(dispatch, locale, model, employeeId, equipmentInventoryId, orderId) {
    try {
        var res = await httpGet(`external/orderRequest/validateMobileServiceType/${employeeId}/${equipmentInventoryId}/${orderId ?? 0}`);

        var errors = {};
        if (res.messages[ERROR_TYPE.existingServiceType]) {
            errors = {
                ...errors,
                warning_existingServiceType: TRANSLATIONS[locale]["warning_existing_service_type"]
            };
        }
        if (res.messages[ERROR_TYPE.existingOpenRequestWithServiceType]) {
            errors = {
                ...errors,
                warning_existingOpenRequestWithServiceType: TRANSLATIONS[locale]["warning_open_request_service_type"]
            };
        }

        if (Object.keys(errors).length > 0) {
            dispatch(actions.setErrors(model, errors));
        }
        else {
            dispatch(actions.resetErrors(model));
            dispatch(actions.reset("wirelessPortInBusinessFormA.termAgreement"))
        }
    }
    catch (e) {
        return;
    }
}

async function getPlanComponentByPlan(dispatch, planId){
    try {
        var res = await httpGet(`external/orderRequest/getInventoryPlanComponentByPlan/${planId}`);

        var dataItem = res.datatable[0].dataItem;
        var totalOrderCost = dataItem.length > 0 ? addZeroes(dataItem[0].TotalComponentCost) : 0;
        dispatch({
            type: getPlanComponent,
            plansDatatable: res.datatable,
            totalOrderCost: totalOrderCost
        });
    }
    catch (e) {
        dispatch({
            type: getPlanComponent,
            plansDatatable: [],
            totalOrderCost: 0
        });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setFormSubmitting:
            return {
                ...state,
                formSubmitting: action.data
            };
        case getOrderRequestForm:
            return {
                ...state,
                orderRequest: action.orderRequest
            };
        case getPlanComponent:
            return {
                ...state,
                plansDatatable: action.plansDatatable,
                totalOrderCost: action.totalOrderCost
            };
        case getVendors:
            const { vendor, vendorPage } = action;
            const vendorList = Array.isArray(vendor) ? vendor : [];

            return {
                ...state,
                vendorOptions: vendorPage === 1 ?
                    vendorList : [...state.vendorOptions, ...vendorList]
                , vendorPage: vendorPage
                , hasMoreVendor: vendorList.length > 0
            };
        case setVendorLoading:
            return {
                ...state,
                isVendorLoading: action.payload
            };
        case getMobileServiceTypes:
            const { mobileServiceTypeOptions, mobServiceTypePage } = action;
            const mobServiceType = Array.isArray(mobileServiceTypeOptions) ? mobileServiceTypeOptions : [];

            return {
                ...state,
                mobileServiceTypeOptions: mobServiceTypePage === 1
                    ? mobServiceType
                    : [...state.mobileServiceTypeOptions, ...mobServiceType]
                , mobServiceTypePage: mobServiceTypePage
                , hasMoreMobServiceType: mobServiceType.length > 0
            };
        case setMobServiceTypeLoading:
            return {
                ...state
                , isMobServiceTypeLoading: action.payload
            }
        case getCircuitTypes:
            const { circuitTypePage, circuitTypeOptions } = action;
            return {
                ...state,
                circuitTypeOptions: circuitTypePage === 1
                    ? circuitTypeOptions
                    : [...state.circuitTypeOptions, ...circuitTypeOptions]
                , circuitTypePage: circuitTypePage
                , hasMoreCircuitType: circuitTypeOptions.length > 0
            };
        case setCircuitTypesLoading:
            return {
                ...state
                , isCircuitTypeLoading: action.payload
            }
        case setLoading:
            if (action.formName == "Subscription") {
                return {
                    ...state,
                    loadingSubscriptionForm: action.isLoading
                };
            }
            else {
                return {
                    ...state,
                    isLoading: action.isLoading
                };
            }
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            const { country, countryPage } = action.payload
            return {
                ...state,
                countryOptions: countryPage === 1
                    ? country : [...state.countryOptions, ...country]
                , countryPage: countryPage
                , hasMoreCountry: country.length > 0
            };
        case setCountryLoading:
            return {
                ...state,
                isCountryLoading: action.payload
            };
        case setAddressOptions:
            const { address, addressPage } = action.payload;
            return {
                ...state,
                addressOptions: addressPage === 1
                ? address : [...state.addressOptions, ...address]
                , addressPage: addressPage
                , hasMoreAddress: address.length > 0
            };
        case setAddressLoading:
            return {
                ...state,
                isAddressLoading: action.payload
            };
        case setPlanOptions:
            const { planType, planPage } = action.payload;
            return {
                ...state,
                planOptions: planPage === 1 ? planType
                    : [...state.planOptions, ...planType]
                , planTypePage: planPage
                , hasMorePlanType: planType.length > 0
            };
        case setPlanOptionLoading:
            return {
                ...state,
                isPlanTypeLoading: action.payload
            };
        case setDeviceOptions:
            return {
                ...state,
                deviceOptions: action.data
            };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetail: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state,
                businessCaseOptions: action.data
            };
        case setShowDeviceOptions:
            return {
                ...state,
                showDeviceOptions: action.data
            };
        case setShowOtherAddress:
            return {
                ...state,
                showOtherAddress: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case setMobileError:
            return {
                ...state,
                mobileError: action.mobileError
            }
        default: return state;
    }
}